import React, { useMemo, useState } from 'react'

import { Integration } from '@/core/api/entities/integration'
import { useIntegrations } from '@/core/hooks/useIntegrations'

import IntegrationsPageUI from './IntegrationsPageUI'

const IntegrationsPage: React.FC = () => {
	const [searchValue, setSearchValue] = useState('')
	const [activeTab, setActiveTab] = useState<'integrations' | 'addons'>(
		'integrations'
	)
	const [isTypeformModalOpen, setIsTypeformModalOpen] = useState(false)

	const { data: integrations = [], isLoading, error } = useIntegrations()

	const filteredIntegrations = useMemo(() => {
		if (!integrations || integrations.length === 0) return []

		return integrations.filter((integration: Integration) => {
			const matchesSearch =
				!searchValue ||
				integration.name.toLowerCase().includes(searchValue.toLowerCase()) ||
				(integration.modal_content &&
					integration.modal_content
						.toLowerCase()
						.includes(searchValue.toLowerCase()))

			const matchesTab =
				activeTab === 'integrations'
					? integration.type === 'integrations'
					: integration.type === 'addons'

			return matchesSearch && matchesTab
		})
	}, [integrations, searchValue, activeTab])

	const handleCloseTypeformModal = () => {
		setIsTypeformModalOpen(false)
	}

	return (
		<IntegrationsPageUI
			integrations={filteredIntegrations}
			isLoading={isLoading}
			error={error}
			searchValue={searchValue}
			activeTab={activeTab}
			isTypeformModalOpen={isTypeformModalOpen}
			onCloseTypeformModal={handleCloseTypeformModal}
			onSearchChange={setSearchValue}
			onTabChange={setActiveTab}
		/>
	)
}

export default IntegrationsPage
